<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-row>
          <b-col cols="12" class="mb-3">
            <b-button type="button" variant="primary" @click="$router.go(-1)" class="pull-left back-btn">Terug</b-button>
          </b-col>
        </b-row>
        <b-form @submit.prevent="saveItem">
          <b-row>
            <b-col>
              <b-alert :show="feedback.show" dismissible :variant="feedback.variant" @dismissed="feedback.show=0" @dismiss-count-down="countDownChanged">
                {{feedback.text}}
                <ul v-if="errors" class="mt-3">
                  <li v-for="error in errors">{{error.toString()}}</li>
                </ul>
              </b-alert>
              <b-card>
                <template #header>
                  <span class="pull-left mt-2"><strong>Bedrijf {{item.name}} (# {{item.id}})</strong></span>
                  <b-button
                    type="button"
                    variant="primary"
                    v-if="!editable"
                    v-can="'bedrijven aanpassen'"
                    @click.prevent="editable = true"
                    class="pull-right ml-3">
                    Bewerken
                  </b-button>
                  <b-button
                    type="button"
                    v-can.disable="'leveringen aanmaken'"
                    @click.prevent="downloadOrdersTemplate"
                    class="pull-right">Download verzamelbestand</b-button>
                </template>
                <b-row>
                  <b-col cols="12" sm="10" md="6">
                    <b-row>
                      <b-col cols="12" md="8">
                        <h5>Basisgegevens</h5>
                        <hr>
                      </b-col>
                      <b-col cols="12" md="8">
                        <b-form-group label="Naam">
                          <b-form-input type="text" required v-model="item.name" :disabled="!editable" />
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="6">
                        <b-form-group label="Maximale bestelwaarde">
                          <b-form-input type="number" required v-model="item.max_order_amount" autocomplete="off" :disabled="!editable" />
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="6">
                        <b-form-group label="Moederbedrijf">
                          <b-form-select :options="companyOptions" v-model="item.parent_company_id" autocomplete="off" :disabled="!editable" />
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row class="mt-4">
                      <b-col cols="12" md="8">
                        <h5>Adresgegevens</h5>
                        <hr>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="8">
                        <b-form-group label="Adres">
                          <b-form-input type="text" required v-model="item.address" autocomplete="off" :disabled="!editable" />
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="3">
                        <b-form-group label="Postcode">
                          <b-form-input type="text" required v-model="item.postal_code" autocomplete="off" :disabled="!editable" />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12" md="5">
                        <b-form-group label="Plaats">
                          <b-form-input type="text" required v-model="item.city" autocomplete="off" :disabled="!editable" />
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="4">
                        <b-form-group label="Land">
                          <b-form-select :options="countryOptions" required v-model="item.country_code" autocomplete="off" :disabled="!editable" />
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row class="mt-4">
                      <b-col cols="12" md="8">
                        <h5>Instellingen</h5>
                        <hr>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="8">
                        <b-form-group label="Petty cash">
                          <b-form-checkbox v-model="item.has_recurring_orders" name="transportOnDemand" :value="true" switch
                                           :disabled="!editable">
                          <span
                            v-if="item.has_recurring_orders">Ja, heeft <strong>wel</strong> herhaalde leveringen</span>
                            <span v-else>Nee, heeft <strong>geen</strong> herhaalde leveringen</span>
                          </b-form-checkbox>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" sm="10" md="6">
                    <b-row>
                      <b-col cols="12">
                        <b-form-group>
                          <b-form-checkbox-group v-model="item.products" name="products" :disabled="!editable" stacked>
                            <b-row>
                              <b-col cols="12" md="6">
                                <b-row>
                                  <b-col cols="12" md="8">
                                    <h5>Leveren</h5>
                                    <hr>
                                  </b-col>
                                </b-row>

                                <b-row>
                                  <b-col cols="12" v-for="(group, name) in groupedProducts.delivery" :key="name">
                                    <b-form-checkbox
                                      v-for="product in group"
                                      :value="product.value"
                                      :key="product.text"
                                      >
                                        {{ product.text }}
                                      </b-form-checkbox>
                                      <hr>
                                  </b-col>
                                </b-row>
                              </b-col>

                              <b-col cols="12" md="6">
                                <b-row>
                                  <b-col cols="12" md="8">
                                    <h5>Ophalen</h5>
                                    <hr>
                                  </b-col>
                                </b-row>

                                <b-row>
                                  <b-col cols="12" v-for="(group, name) in groupedProducts.pickup" :key="name">
                                    <b-form-checkbox
                                      v-for="product in group"
                                      :value="product.value"
                                      :key="product.text"
                                      >
                                        {{ product.text }}
                                      </b-form-checkbox>
                                      <hr>
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-row>
                          </b-form-checkbox-group>
                        </b-form-group>
                        <hr v-if="editable">
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>

          <b-row v-if="editable">
            <b-col cols="12" class="mb-4">
              <b-card>
                <b-button type="submit" variant="primary" class="mr-3" :disabled="saveButtonDisabled">Wijzigingen opslaan</b-button>
                <b-button @click.prevent="cancelEdit">Annuleren</b-button>
              </b-card>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>
  </div>
</template>
<script>
import { updateData, getData, download } from '../../api';

export default {
  name: 'company',
  props: ['id'],
  data() {
    return {
      saveButtonDisabled: false,
      feedback: {
        show: false,
        text: '',
        variant: null,
        dismissCountDown: 4
      },
      editable: false,
      companyOptions: [],
      countryOptions: [],
      item: {},
      products: [],
      groupedProducts: {
        delivery: {},
        pickup: {},
      },
      errors: null,
    }
  },
  methods: {
    async getItem() {
      const item = await getData('companies/' + this.$route.params.id).then(response => response.data);
      this.item = item.data;
    },
    async getCompanyOptions() {
      const options = await getData('companies/' + this.$route.params.id + '/options').then(response => response.data);
      this.companyOptions = options.data;
      this.companyOptions.unshift({ text: "Geen moederbedrijf", value: null });
    },
    async getCountries() {
      const countries = await getData('countries').then(response => response.data);
      this.countryOptions = countries.data;
    },
    async getProducts() {
      const products = await getData('products').then(response => response.data);
      this.products = products.data;
      this.groupedProducts = this.parseProducts(products.data);
    },
    async saveItem() {
      this.errors = null;
      this.saveButtonDisabled = true;
      this.item.products = JSON.stringify(this.item.products);
      const request = await updateData('companies/' + this.$route.params.id, this.item);
      if (request.status === 200) {
        this.feedback.show = true;
        this.feedback.text = 'Bedrijf succesvol geupdate';
        this.feedback.variant = 'success';
        this.editable = false;
        this.saveButtonDisabled = false;
        this.getItem();
      } else {
        this.errors = request.data.errors;
        this.feedback.show = true;
        this.feedback.text = 'Er ging iets mis...';
        this.feedback.variant = 'danger';
        this.editable = true;
        this.saveButtonDisabled = false;
        this.getItem();
      }
    },
      parseProducts(products) {
        const collection = {
          delivery: {},
          pickup: {},
        };

        let n = 0;
        let len = products.length;

        for (n; n < len; n++) {
          const product = products[n];
          const arr = product.text.split('€');
          const {transport, subgroup} = product;

          if (!collection[transport][subgroup]) collection[transport][subgroup] = [];
          collection[transport][subgroup].push(product);
        }

        return collection;
      },
    async downloadOrdersTemplate() {
      await download(`companies/${this.$route.params.id}/orders-template`);
    },
    cancelEdit() {
      this.editable = false;
      this.getItem();
    },
    countDownChanged(dismissCountDown) {
      this.feedback.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.this.feedback.dismissCountDown = this.dismissSecs
    }
  },
  beforeMount() {
    this.getItem();
    this.getCompanyOptions();
    this.getCountries();
    this.getProducts();
  },
  computed: {
    userRole() {
      return this.$store.state.userRole
    },
  },
}

</script>
